import React, { useState } from "react";
import { useRoutes } from "react-router-dom";
// routes
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// login option 3 routing
import layouts from "../layouts";
import screens from "../screens";
import { Typography } from "@mui/material";
import axios from "axios";
// ==============================|| ROUTING RENDER ||============================== //
function RoutesCommponent({ web3, initWeb3, contracts }) {
  console.log("Routes COmponent Data", web3, initWeb3, contracts);

  const [ethAmount, setEthAmount] = useState("");
  const [usdAmount, setUsdAmount] = useState("");
  const handleEthInputChange = (e) => {
    const inputEthValue = e.target.value;
    setEthAmount(inputEthValue);
    axios
      .get("https://api.coingecko.com/api/v3/simple/price", {
        params: {
          ids: "ethereum",
          vs_currencies: "usd",
        },
      })

      .then((response) => {
        const exchangeRate = response.data.ethereum.usd;
        const convertedUsdAmount = parseFloat(inputEthValue) * exchangeRate;
        setUsdAmount(convertedUsdAmount.toFixed(10));
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth" element={<layouts.AuthLayout />}>
          <Route
            path="registerProvider"
            element={<screens.auth.registerProvider />}
          />
          <Route
            path="registerFundSubscriber"
            element={<screens.auth.RegisterFundSubscriber />}
          />
          <Route path="Login" element={<screens.auth.login />} />
          <Route path="varifyOTP" element={<screens.auth.varifyOTP />} />
          <Route path=":mode/varifyOTP" element={<screens.auth.varifyOTP />} />
          <Route path="varifyEmail" element={<screens.auth.varifyEmail />} />
          <Route
            path="resetPassword"
            element={<screens.auth.resetPassword />}
          />
        </Route>
        <Route path="/admin-panel" element={<layouts.mainLayout />}>
          <Route path="Dashboard" element={<screens.dashboard.Dashboard />} />

          <Route
            path="FundSubscriberProfile"
            element={<screens.profile.fundSubscriberProfile />}
          />
          <Route
            path="AdminProfile"
            element={<screens.profile.adminProfile />}
          />

          <Route
            path="ConnectToWallet"
            element={<screens.profile.ConnectToWallet />}
          />

          {/* Removed FundProviderDashboard route as it's not required */}

          <Route
            path="ProviderProfile"
            element={<screens.profile.providerProfile />}
          />

          <Route
            path="FundSubscriberDataConsumersProviderMain/Transactions/:id"
            element={
              <screens.FundSubscriberDataConsumersProviderMain.FundSubscriberConsumerPurchasedDataUnits />
            }
          />

          <Route path="Sales" element={<screens.sales.Sales />} />
          <Route
            path="Sales/TransactionDetails/:id"
            element={<screens.sales.SalesDetails />}
          />
          <Route
            path="Sales/TransactionDetails/BuyTransactionDetails/:id"
            element={<screens.sales.Sales3 />}
          />

          <Route path="BuyFundAssets" element={<screens.buyFundAssets.BuyFundAssets />} />
          <Route path="FundUnits" element={<screens.fundUnits.FundUnits />} />
          <Route path="FundProvider" element={<screens.fundProvider.FundProvider />} />
          <Route path="FundSubscriber" element={<screens.fundSubscriber />} />
          <Route
            path="SalesBalance"
            element={<screens.salesAndBalance.SalesAndBalance />}
          />
          <Route path="FundInvestments" element={<screens.fundInvestments.FundInvestments />} />
          <Route path="tokenizeData" element={<screens.tokenizeData.TokenizeData />} />
          <Route path="BuyData" element={<screens.buyData.BuyData />} />
          <Route path="YourdataUnit" element={<screens.YourDataUnit.Yourdata />} />
          <Route path="PurchasedDataUnit" element={<screens.purchasedDataUnit.PurchasedDataUnit />} />
          <Route path="PurchasedDataUnit/PurchasedDataUnit_Details/:id/:buyerId?" element={<screens.purchasedDataUnit.PurchasedDataUnit_Details />} />
          <Route path="DataTransaction" element={<screens.dataTransaction.DataTransaction />} />
          <Route path="FundSubscriberTransactions/:id" element={<screens.FundSubscriberTransactionsMain.FundSubscriberTransactions />} />
          <Route path="FundSubscriberTransactions/:id/:fundName/:levelName" element={<screens.FundSubscriberTransactionsMain.FundSubscriberTransactionDetails />} />
          <Route path="CheckProviderDetail" element={<screens.checkProviderDetail.CheckProviderDetail />} />
          <Route path="CheckProviderDetail/RegisterNewDataProvider" element={<screens.registerProvider.registerProviderMain />} />
          <Route path="CheckProviderDetail/PermissionsDetail/:id" element={<screens.checkProviderDetail.PermissionsDetail />} />
          <Route path="viewProvider" element={<screens.registerProvider.ViewProvider />} />
          <Route path="CheckConsumerDetail" element={<screens.CheckConsumerDetail.CheckConsumerDetail />} />
          <Route path="CheckDataUnitbyType" element={<screens.checkDataUnitbyType.CheckDataUnitbyType />} />
          <Route path="ProviderFundSubscribers" element={<screens.DataConsumersProviderMain.ProviderDataConsumer />} />
        </Route>
        <Route path="/" element={<Navigate to="/auth/Login" />} />
        <Route path="*" element={<Typography>Route not found</Typography>} />
      </Routes>
    </BrowserRouter>
  );
}
export default RoutesCommponent;